import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@app/shared/forms';
import { LoaderModule, PaginationIntergratedModule } from '@app/shared';
import { AchievementsListComponent } from './list.component';
import { DataTestModule } from '@app/shared/directive/data-test';
import { AchievementModule } from '../achievement/achievement.module';
import { PerfectScrollbarModule } from '@app/shared/perfect-scrollbar/perfect-scrollbar.module';

@NgModule({
    imports: [CommonModule, TranslateModule, FormsModule, LoaderModule, PaginationIntergratedModule, DataTestModule, AchievementModule, PerfectScrollbarModule],
    declarations: [AchievementsListComponent],
    exports: [AchievementsListComponent],
})
export class AchievementsListModule {}
